// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._comparisonFooter__row_fl172_1 {
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  grid-auto-rows: 0;
  overflow: hidden;
}
@media (min-width: 1200px) {
  ._comparisonFooter__row_fl172_1 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 36px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._comparisonFooter__row_fl172_1 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  ._comparisonFooter__row_fl172_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 28px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  ._comparisonFooter__row_fl172_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  ._comparisonFooter__row_fl172_1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
